import React from 'react';
import Tremor from './Tremor';
import texts from './data.js';

const TremorCanvas = () => {
  return (
    <div style={{ width: '100%', height: '100%', cursor: 'none' }}>
      <Tremor
        curveCount={100}
        colors={['blue']}
        texts={texts[0]}
      />
      <Tremor
        curveCount={100}
        colors={['orange', 'purple']}
        texts={texts[1]}
      />
      <Tremor
        curveCount={100}
        colors={['#EA4B48', '#E52724', '#DD1C1A']}
        texts={texts[2]}
      />
    </div>
  );
};

export default TremorCanvas;
